import React, { useEffect, useState } from "react";
import Input from "../input/Input";
import SearchDropdown from "../input/SearchDropdown";
import { getBulkDropdownData, getOtherRefDetails } from "../../api/keyvalue";
import Button from "../input/Button";
import { toast } from "react-toastify";
import Dropdown from "../input/Dropdown";
import LoadingSpinner from "../LoadingSpinner";
import {Download} from "react-feather";

function EvInvSearch({ searchResHandler, resetHandler, handleDownload, isDownloading, jobs}) {
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [jobStatus, setJobStatus] = useState("");
  const [jobNos, setJobNos] = useState("");
  const [reqNos, setReqNos] = useState("");

  const [invCustomer, setInvCustomer] = useState("");
  const [customer, setCustomer] = useState([]);
  const [shipper, setShipper] = useState([]);
  const [transporter, setTransporter] = useState("");
  const [veh, setVeh] = useState("");
  const [type, setType] = useState(null);
  const [dateType, setDateType] = useState("");
  const [dateTypeOpt, setDateTypeOpt] = useState([]);

  const [reloadDates, setReloadDates] = useState(true);
  const [resetSearchFields, setResetSearchFields] = useState(false);
  const [eihCode, setEihCode] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [evStatus, setEvStatus] = useState(null);
  const [invStatus, setInvStatus] = useState(null);
  const [dropdownLoading, setDropdownLoading] = useState(false);

  useEffect(() => {
    if (reloadDates) {
      const aWeekAgo = new Date();
      aWeekAgo.setDate(aWeekAgo.getDate() - 7);
      const formattedWeekAgo = aWeekAgo.toISOString().split("T")[0];
      const formattedToday = new Date().toISOString().split("T")[0];
      console.log(formattedToday, formattedWeekAgo);
      setFromDate(formattedWeekAgo);
      setToDate(formattedToday);
    }
    (async () => {
      setDropdownLoading(true);
      const { ev_inv_status: evInvStatus = [], date_types: dateTypeData } =
        await getBulkDropdownData([
          { key: "ev_inv_status" },
          { key: "date_types" },
        ]);
      setStatusOptions(evInvStatus);
      setDateTypeOpt(dateTypeData);
      setDropdownLoading(false);
    })();
    setReloadDates(false);
  }, [reloadDates]);

  const onReset = (e) => {
    e.preventDefault();
    setResetSearchFields(true);
    setVeh("");
    setInvCustomer("");
    setDateType("");
    setCustomer([]);
    setShipper([]);
    setJobStatus("");
    setTransporter("");
    setReloadDates(true);
    setJobNos("");
    setReqNos("");
    setEihCode("");
    setType("");
    setEvStatus("");
    setInvStatus("");
    resetHandler();
  };

  const onSearch = (e) => {
    e.preventDefault();
    if (type === 2 && !customer && !transporter) {
      toast.warn("Customer or Transporter is mandatory for Bulk invoices", {
        autoClose: 5000,
        containerId: "Main",
      });
      return;
    }
    searchResHandler({
      dDateType: dateType ? dateType : null,
      dFromDate: fromDate,
      dToDate: toDate,
      sInvCustomer: invCustomer.toString(),
      sCustomer: customer.length > 0 ? customer.join(",") : null,
      sTransporter: transporter.toString(),
      sJobStatus: jobStatus.toString(),
      sJobs: jobNos,
      eihCode: eihCode,
      sVehicle: veh.toString(),
      sType: type,
      shipper: shipper.length > 0 ? shipper.join(",") : null,
      request: reqNos,
      evStatus: evStatus,
      invStatus: invStatus,
    });
  };
  return (
    <>
      {dropdownLoading ? (
        <LoadingSpinner />
      ) : (
        <form className="ui form">
          <h4 className="ui dividing header">EV/INV Search</h4>
          <div
            className="four fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Dropdown
              // required={true}
              options={dateTypeOpt}
              label="Date Type"
              placeholder="Date Type"
              style={{ height: "20px" }}
              value={dateType}
              onChange={(e, data) => {
                setDateType(data.value);
              }}
              clearable={false}
            />
            <Input
              label="From Date"
              type="date"
              name="fromDate"
              value={fromDate}
              onChange={(e) => {
                setFromDate(e.target.value);
              }}
            />

            <Input
              label={"To Date"}
              type="date"
              name="toDate"
              value={toDate}
              onChange={(e) => {
                setToDate(e.target.value);
              }}
            />

            <Input
              label="Job Numbers"
              type="text"
              placeholder="Example - JOB-00000001,JOB-00000002"
              name="jobnos"
              value={jobNos}
              onChange={(e) => {
                setJobNos(e.target.value);
              }}
            />
          </div>
          <div
            className="four fields"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Input
              label="Req Numbers"
              type="text"
              placeholder="Example - REQ-00000001,REQ-00000002"
              name="reqNos"
              value={reqNos}
              onChange={(e) => {
                setReqNos(e.target.value);
              }}
            />
            <SearchDropdown
              key={1}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setInvCustomer(data.value);
              }}
              clearable={true}
              onClear={() => {
                setInvCustomer("");
              }}
              returnFullObject={true}
              api={getOtherRefDetails}
              apiDependency={{
                type: "stakeholder_type",
                value: "Invoicee Customer",
              }}
              label="Invoicee Customer"
            />
            <SearchDropdown
              key={3}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setTransporter(data.value);
              }}
              clearable={true}
              onClear={() => {
                setTransporter("");
              }}
              returnFullObject={true}
              api={getOtherRefDetails}
              apiDependency={{ type: "stakeholder_type", value: "transporter_all" }}
              label="Transporter"
            />

            <SearchDropdown
              key={4}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              onResultSelect={(data) => {
                setVeh(data.value);
              }}
              clearable={true}
              onClear={() => {
                setVeh("");
              }}
              returnFullObject={true}
              api={getOtherRefDetails}
              apiDependency={{ type: "vehicle", value: "" }}
              label="Vehicle"
            />
          </div>
          <div className="four fields">
            <SearchDropdown
              key={2}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              occupySpace={false}
              multiple={true}
              multiValueRemoveHandler={(key) => {
                setCustomer((prev) =>
                  prev.filter((item) => item !== parseInt(key))
                );
              }}
              onResultSelect={(data) => setCustomer((prev) => [...prev, data])}
              api={getOtherRefDetails}
              apiDependency={{ type: "stakeholder_type", value: "Customer" }}
              label="Customer"
            />
            <SearchDropdown
              key={2}
              editMode={false}
              reset={resetSearchFields}
              setReset={setResetSearchFields}
              occupySpace={false}
              multiple={true}
              multiValueRemoveHandler={(key) => {
                setShipper((prev) =>
                  prev.filter((item) => item !== parseInt(key))
                );
              }}
              onResultSelect={(data) => setShipper((prev) => [...prev, data])}
              api={getOtherRefDetails}
              apiDependency={{ type: "stakeholder_type", value: "Shipper" }}
              label="Shipper"
            />
            <Dropdown
              label="EV Status"
              options={statusOptions}
              placeholder="Status"
              style={{ height: "20px" }}
              value={evStatus}
              onChange={(e, data) => {
                setEvStatus(data.value);
              }}
            />
            <Dropdown
              label="INV Status"
              options={statusOptions}
              placeholder="Active"
              style={{ height: "20px" }}
              value={invStatus}
              onChange={(e, data) => {
                setInvStatus(data.value);
              }}
            />
          </div>
          <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
          >
            <div>
              {jobs?.length > 0 ? (
                  <Button
                      Icon={Download}
                      label="Generate Report"
                      onClick={handleDownload}
                      isLoading={isDownloading}
                  />
              ) : (
                  <div style={{ width: 140 }} />
                )}
            </div>

            <div>
              <Button template="search" onClick={onSearch} />
              <Button template="searchReset" onClick={onReset} />
            </div>
          </div>

        </form>
      )}
    </>
  );
}

export default EvInvSearch;
